import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './VendorLogin.css';

const VendorLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: 'contact@techsolutions.com',
    password: 'Vendor@123'
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
console.log("formData", formData)
// return false;
    try {
      let url = `${process.env.REACT_APP_API_URL}/api/v1/vendor-auth/login`
      const response = await axios.post(
        url,
        formData
      );

      console.log("urll",url)

      // Store vendor token and info
      localStorage.setItem('vendorToken', response.data.token);
      localStorage.setItem('vendorInfo', JSON.stringify(response.data.contact));
      localStorage.setItem('userType', 'vendor');
      console.log("response.data.token", response.data)
      // Redirect to vendor dashboard
      navigate('/vendor/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vendor-login-container">
      <div className="vendor-login-card">
        <div className="vendor-login-header">
          <h1>Tenant Portal</h1>
          <p>Sign in to access your dashboard</p>
        </div>

        {error && (
          <div className="error-message">
            <i className="fas fa-exclamation-circle"></i>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="vendor-login-form">
          <div className="form-group">
            <label htmlFor="email">  
              <i className="fas fa-envelope" style={{"margin-right": "2%"}}></i>
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="your.email@company.com"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">
              <i className="fas fa-lock" style={{"margin-right": "2%"}}></i>
              Password
            </label>
            <div className="password-container">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter your password"
              required
              disabled={loading}
            />
             <i
      className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
      onClick={() => setShowPassword(!showPassword)}
    />
        </div>
          </div>

          <button 
            type="submit" 
            className="vendor-login-button"
            disabled={loading}
          >
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i>
                Signing in...
              </>
            ) : (
              <>
                <i className="fas fa-sign-in-alt"></i>
                Sign In
              </>
            )}
          </button>
        </form>

        <div className="vendor-login-footer">
          <p>Need help? Contact your organization administrator</p>
          {/* <div className="test-credentials">
            <small>
              <strong>Test Credentials:</strong><br />
              Email: contact@techsolutions.com<br />
              Password: Vendor@123
            </small>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default VendorLogin;


